import { useAppDispatch, useAppSelector } from '../store/hooks';
import { selectAllSchemas, selectErrorsForSchemas, selectIsLoadingSchemas } from '../store/schemas/schemasSelector';
import { useCallback, useEffect } from 'react';
import { fetchAllSchemas } from '../store/schemas/schemasActions';
import { SchemaModel } from '../models/schemaModel';
import { AppError } from '../types/appError';

export const useSchemaList = (): [
  { schemas: SchemaModel[], isLoading: boolean, errors: AppError[] },
  { refreshAll: () => void },
] => {
  const dispatch = useAppDispatch();
  const schemas = useAppSelector(selectAllSchemas);
  const isLoading = useAppSelector(selectIsLoadingSchemas);
  const errors = useAppSelector(selectErrorsForSchemas);

  const fetchSchemas = useCallback(() => {
    dispatch(fetchAllSchemas());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllSchemas());
  }, [dispatch]);

  return [
    { schemas, isLoading, errors },
    { refreshAll: fetchSchemas },
  ];
};
